// extracted by mini-css-extract-plugin
module.exports = {"slide":"MemberForm_slide_hXaJI","slide-reverse":"MemberForm_slide-reverse_3QoAa","orderformSection":"MemberForm_orderformSection_201Ya"};